export default {
  imageExtensions: ['.tiff', '.psd', '.jpg', '.png', '.gif', '.bmp', '.jpeg', '.heic'],
  imageExtensionsWithoutDot: ['tiff', 'psd', 'jpg', 'png', 'gif', 'bmp', 'jpeg', 'heic'],
  pdfExtensions: ['.pdf'],
  pdfExtensionsWithoutDot: ['pdf'],
  xlsxExtensionsWithoutDot: ['xlsx'],
  docxExtensionsWithoutDot: ['docx'],
  inputAcceptFileType: {
    image: 'image/*',
    pdf: '.pdf,application/pdf',
    xlsx: '.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    docx: '.docx,application/vnd.openxmlformats-officedocument.wordprocessingml.sheet',
  },
  columnHeader: {
    index: [
      {
        type: 'slot',
        tabletHide: false,
        width: '40px',
      },
      {
        id: 'name',
        textLabel: '標題',
        type: 'text',
        tabletHide: false,
        flex: true,
      },
      {
        id: 'path',
        textLabel: '路徑',
        type: 'text',
        tabletHide: false,
      },
      {
        id: 'versionNumber',
        textLabel: '版本',
        type: 'text',
        tabletHide: false,
        width: '70px'
      },
      {
        id: 'createdUser',
        textLabel: '上傳者',
        type: 'avatar',
        tabletHide: false,
        width: '100px',
      },
      {
        id: 'createdAt',
        textLabel: '建立時間',
        type: 'text',
        tabletHide: true,
        width: '200px',
      },
      {
        id: 'updatedAt',
        textLabel: '更新時間',
        type: 'text',
        tabletHide: false,
        width: '200px',
      },
      {
        id: 'info',
        type: 'icon',
        tabletHide: false,
        toolTip: {
          size: 'h5',
          text: '檢視資料夾資訊',
        },
        width: '24px',
      },
      {
        id: 'iconNavDrawer',
        type: 'iconNavDrawer',
        tabletHide: false,
        width: '24px',
      },
    ],
    path: [
      {
        id: 'name',
        textLabel: '名稱',
        type: 'text',
        tabletHide: false,
      },
      {
        id: 'path',
        textLabel: '路徑',
        type: 'text',
        tabletHide: false,
      },
      {
        id: 'createdAt',
        textLabel: '建立時間',
        type: 'text',
        tabletHide: true,
        width: '200px',
      },
      {
        id: 'updatedAt',
        textLabel: '更新時間',
        type: 'text',
        tabletHide: false,
        width: '200px',
      },
    ],
    history: [
      {
        id: 'name',
        textLabel: '標題',
        type: 'text',
        tabletHide: false,
      },
      {
        id: 'versionNumber',
        textLabel: '版本',
        type: 'text',
        tabletHide: false,
        width: '70px'
      },
      {
        id: 'createdUser',
        textLabel: '上傳者',
        type: 'avatar',
        tabletHide: false,
        width: '100px',
      },
      {
        id: 'createdAt',
        textLabel: '上傳時間',
        type: 'text',
        tabletHide: true,
        width: '200px',
      },
      {
        id: 'download',
        type: 'icon',
        tabletHide: false,
        width: '50px',
      },
    ],
    activity: [
      {
        id: 'action',
        textLabel: '動作',
        type: 'text',
        tabletHide: false,
      },
      {
        id: 'createdUser',
        textLabel: '人員',
        type: 'avatar',
        tabletHide: false,
        width: '100px',
      },
      {
        id: 'createdAt',
        textLabel: '時間',
        type: 'text',
        tabletHide: false,
        width: '200px',
      },
      {
        id: 'info',
        type: 'icon',
        tabletHide: false,
        width: '50px',
      },
    ],
    upload: [
      {
        id: 'isChecked',
        type: 'slot',
        tabletHide: false,
        width: '50px',
      },
      {
        id: 'name',
        textLabel: '標題',
        type: 'slot',
        tabletHide: false,
      },
      {
        id: 'createdAt',
        textLabel: '建立時間',
        type: 'text',
        tabletHide: false,
        width: '200px',
      },
      {
        id: 'updatedAt',
        textLabel: '更新時間',
        type: 'text',
        tabletHide: false,
        width: '200px',
      },
      {
        id: 'info',
        type: 'icon',
        tabletHide: false,
        width: '50px',
      },
    ],
  },
  filterFieldTypes: {
    index: [
      {
        name: 'searchType',
        type: 'radio-dropdown',
      },
      {
        name: 'search',
        type: 'search',
      },
      {
        name: 'createdUser',
        type: 'avatars',
        title: '上傳者',
      },
      {
        name: 'updatedAt',
        type: 'date-duration',
        defaultValue: {
          start: '',
          end: '',
        }
      },
      {
        name: 'order',
        type: 'radio-dropdown',
      }
    ],
    path: [
      {
        name: 'search',
        type: 'search',
        isTitleHide: true,
        placeholder: '搜尋資料夾名稱',
        cols: 12,
      },
    ],
    history: [
      {
        name: 'search',
        type: 'search',
        title: '標題',
      },
      {
        name: 'createdUser',
        type: 'avatar',
        title: '上傳者',
      },
      {
        name: 'createdAt',
        type: 'date-duration',
        title: '上傳日期',
        defaultValue: {start: '', end: ''},
      },
      {
        name: 'order',
        type: 'radio-dropdown',
        defaultValue: 'desc',
        getItems: () => {
          return [
            {
              id: 'desc',
              textLabel: '依建立日期由近至遠',
            },
            {
              id: 'asc',
              textLabel: '依建立日期由遠至近',
            },
          ];
        }
      }
    ],
    upload: [
      {
        name: 'search',
        type: 'search',
        title: '標題',
        cols: 6,
      },
      {
        name: 'filePath',
        type: 'search',
        title: '路徑',
        cols: 6,
      },
      {
        name: 'order',
        type: 'radio-dropdown',
        cols: 6,
      },
      {
        name: 'duration',
        type: 'date-duration',
        title: '建立日期',
        cols: 6,
      },
    ]
  },
  customBtnList: [
    {
      value: 'createFolder',
      text: '新增資料夾',
    },
    {
      value: 'createFile',
      text: '新增檔案',
    },
  ],
  invalid: {
    text: '已作廢',
    color: 'red',
    icon: 'icon-md-archive',
  },
  movePopup: {
    file: {
      titleLabel: '移動檔案位置',
      nameLabel: '標題',
      ingLocationLabel: '目前檔案所在位置',
      warning: '請注意，當您移動本檔案位置後，檔案瀏覽權限可能發生變化。',
    },
    folder: {
      titleLabel: '移動資料夾位置',
      nameLabel: '標題',
      ingLocationLabel: '目前資料夾所在位置',
      warning: '請注意，當您移動本資料夾位置後，資料夾權限可能發生變化。',
    }
  },
  warning: {
    shareFactories: [
      '請注意，當您將資料夾分享至其他單位，將分享此資料夾下的所有檔案，但不會分享子資料夾',
      '請注意，當您將資料夾分享至其他單位，非本單位只能唯讀',
    ],
    isSecret: [
      '請注意，當您將資料夾設為機密，只有權限人員可看到此資料夾名稱'
    ],
    delete: '確定刪除嗎？',
    removeAndDelete: '確定要移除與此檔案的關聯且刪除檔案嗎？ 請注意，刪除檔案也會連同文件檔案庫的檔案一起刪除。',
    usedAndRemove: '此檔案正在使用中，僅可以移除關聯，確定要移除與此檔案的關聯嗎？',
    noScopeAndRemove: '對此檔案無刪除權限，僅可以移除關聯，確定要移除與此檔案的關聯嗎？',
    canNotDeleteFile: '此檔案正在被使用中，無法刪除。',
    noDeleteScope: '對此檔案無刪除權限',
    canNotDeleteFolder: '尚有資料夾或檔案在此資料夾中，所以無法刪除。如需要刪除，請先清空此資料夾。',
  },
  tabItems: {
    index: [
      {
        id: 'thisUnit',
        textLabel: '本單位',
      },
      {
        id: 'toOtherUnits',
        textLabel: '分享至其他單位',
      },
      {
        id: 'fromOtherUnits',
        textLabel: '其他單位的分享',
      },
      {
        id: 'systemFolder',
        textLabel: '系統資料夾'
      }
    ],
  },
  uploadModule: {
    internalTraining: 'internal_training',
    contractorEnterRecord: 'contractor_enter_record',
    contractorLicenseVersion: 'contractor_license_version',
    contract: 'contract',
    contractor: 'contractor',
    license: 'license_version',
    task: 'task',
    event: 'event',
    checklistQuestionVersion: 'checklist_question_version',
    checklistRecordAnswer: 'checklist_record_answer',
    checklistRecord: 'checklist_record',
    auditQuestionVersion: 'audit_question_version',
    auditRecordAnswer: 'audit_record_answer',
    auditRecord: 'audit_record',
    changeVersion: 'change_version',
    changeRecordAnswer: 'change_record_answer',
    exitCheckItem: 'exit_check_item',
    exitChecklist: 'exit_checklist',
    retraining: 'retraining_time_record',
    auditSurvey: 'audit_survey',
    meeting: 'meeting',
    meetingItem: 'meeting_item',
    meetingTemplate: 'meeting_template',
    taskTemplate: 'task_factory_template',
    subTaskTemplate: 'subtask_factory_template',
  }
}
